import { captureException } from '@sentry/react'
import {
  compressToEncodedURIComponent,
  decompressFromEncodedURIComponent,
} from 'lz-string'

import { packState, unpackState } from './packState'

export const encodeState = (data: unknown): string => {
  if (data === undefined || data === null) {
    return ''
  }

  if (typeof data === 'object' && Object.keys(data).length === 0) {
    return ''
  }

  try {
    const packedData = packState(data)
    const json = JSON.stringify(packedData)

    return compressToEncodedURIComponent(json)
  } catch (error) {
    captureException(error)
    return ''
  }
}

export const decodeState = <T>(str: string | null): T | null => {
  if (!str) {
    return null
  }

  try {
    const json = decompressFromEncodedURIComponent(str)

    if (!json) {
      return null
    }

    const packedData = JSON.parse(json)

    return unpackState(packedData) as T
  } catch (error) {
    captureException(error)
    return null
  }
}
